import { type MediumIcon } from '@factorialco/deprecated-design-system'

import { ChargeType, Currency, PeriodUnit, PricingModel, Tier } from './selfUpsell/types'

export const isValidIconMediumType = (value: string | null | undefined): value is MediumIcon => {
  if (!value) return false
  return typeof value === 'string' && value.length > 0
}

export const getValidCurrency = (value: string | null | undefined): Currency => {
  if (!value) return 'EUR'

  switch (value) {
    case 'EUR':
    case 'USD':
    case 'GBP':
    case 'MXN':
    case 'BRL':
    case 'COP':
    case 'ARS':
      return value
    default:
      return 'EUR'
  }
}

export const getValidPeriodUnit = (value: string | null | undefined): PeriodUnit => {
  if (!value) return 'month'

  switch (value) {
    case 'month':
    case 'year':
      return value
    default:
      return 'month'
  }
}

export const getValidPricingModel = (value: string | null | undefined): PricingModel => {
  if (!value) return 'flat_fee'

  switch (value) {
    case 'flat_fee':
    case 'per_unit':
    case 'tiered':
    case 'stairstep':
      return value
    default:
      return 'flat_fee'
  }
}

export const getValidChargeType = (value: string | null | undefined): ChargeType => {
  if (!value) return 'recurring'

  switch (value) {
    case 'recurring':
    case 'non_recurring':
      return value
    default:
      return 'recurring'
  }
}

export const isValidTier = (value: {
  price: number
  startingUnit?: number
  endingUnit?: number
}): value is Tier => {
  if (!value || typeof value !== 'object') return false
  return (
    typeof value.price === 'number' &&
    (value.startingUnit === undefined || typeof value.startingUnit === 'number') &&
    (value.endingUnit === undefined || typeof value.endingUnit === 'number')
  )
}
